import { useCallback, useState } from "react";
import type { ReactElement } from "react";
import { TicketDialog } from "../../../views/tickets/TicketDialog.js";
import { verknuepfungenReiter } from "../../../views/tickets/TicketVerknuepfungen.js";
import { HIERARCHY_TEXT } from "../../../views/tickets/hierarchyTexts.js";
import type { GastBezug } from "../objektBezug.js";
import { useObjektPanel } from "../ObjektPanelKontext.js";
import type { InhaltProps } from "../ObjektPanelGastgeber.js";

/**
 * DAS TICKET IM OBJEKTPANEL (Spec F6; Plan Aufgabe 2): der `TicketDialog` selbst — er ist schon ein Panel — mit `verlauf`
 * (Entscheid 696), dem Sprungknopf links unten (F11) und seitlich, wenn der Gastgeber es so legt. Ein anderes Objekt aus dem
 * Dialog (Eltern- oder Kind-Ticket, Meilenstein aus „Verknüpfungen“): aus der Hauptebene seitlich daneben — schreibt es,
 * lädt dieser Dialog nach (`reloadToken`); aus der seitlichen Ebene ersetzt es diese (`onWechsel`, F5). Liegt es schon
 * darunter, schließt der Gastgeber die Ebene darüber (F14). Bezüge tragen ihren Verweis selbst (K6): aus dem Panel heraus
 * öffnen sie seitlich, ihr Sprung geht durch den Ausgang.
 */
export function TicketInhalt(p: InhaltProps<"ticket">): ReactElement {
  const wege = useObjektPanel();
  const [nachladen, setNachladen] = useState(0);
  const neuLaden = useCallback(() => setNachladen((n) => n + 1), []);
  const zeige = (b: GastBezug): void => {
    if (p.seitlich) p.onWechsel(b);
    else wege.oeffne(b, { onGeaendert: neuLaden });
  };
  // Der Gastgeber öffnet ein Ticket nur mit eigener Kennung (F12, `darf`).
  const ich = p.rechte.ich!;
  return (
    <TicketDialog client={p.client} ticketId={p.bezug.id} companies={p.companies}
      ich={{ id: ich.id, istAdmin: ich.istAdmin, supplierView: p.rechte.supplierView }}
      pfad={HIERARCHY_TEXT.panelPath} verlauf verweis={p.sprung} {...(p.seitlich ? { unter: "seitlich" as const } : {})}
      reloadToken={nachladen} onUngespeichert={p.onUngespeichert} onGeaendert={p.onGeaendert}
      onSchliessen={(geaendert) => { if (geaendert) p.onGeaendert(); p.onSchliessen(); }}
      onOpenTicket={(id) => zeige({ art: "ticket", id })}
      zusatzReiter={[verknuepfungenReiter(p.client, (d, m) =>
        zeige({ art: "meilenstein", id: m.id, label: m.title, companyId: d.companyId }))]} />
  );
}
